<template>
  <div>
    <template v-for="(item, index) in dataList">
      <a-tag :key="getItemKey(item,index)" :closable="true" @close="() => handleClose(item,index)">
        {{ getTagName(item) }}
      </a-tag>
    </template>
    <AreaSelected
      v-if="inputVisible"
      ref="input"
      @blur="onFocusoutEvent"
      :changeOnSelect="changeOnSelect"
      :only-city="onlyCity"
      :area-type="areaType"
      :style="{ width: inputWidth }"
    />
    <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
      <a-icon type="plus" style="margin-right: 6px"/>
      {{ addTagName }}
    </a-tag>
  </div>
</template>
<script>
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'

export default {
  name: 'MultipleAreaSelected',
  components: { AreaSelected },
  props: {

    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    //all 所有地址 ,out 国外,in国内
    areaType: {
      type: String,
      default: 'in'
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    onlyCity: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 20
    },
    inputWidth: {
      type: String,
      default: '200px'
    },
    addTagName: {
      type: String,
      default: '添加'
    }
  },
  watch: {
    'value': function(newVal, oldVal) {
      this.dataList = newVal ? [...newVal] : []
    }
  },

  mounted() {
    this.dataList = this.value ? [...this.value] : []
  },
  data() {
    return {
      dataList: [],
      inputVisible: false
    }
  },
  methods: {
    getItemKey(item, index) {
      let itemKey = index
      for (let key in item) {
        itemKey = itemKey + (item[key] ? item[key] : '')
      }
      return itemKey
    },
    getTagName(item) {
      if (item.provinceName) {
        return item.provinceName + '/' + item.cityName + (item.countyName ? ('/' + item.countyName) : '')
      } else if (item.countryName) {
        return item.countryName + '/' + item.cityName
      }
    },
    handleClose(removedItem, removeIndex) {
      this.dataList = this.dataList.filter((item, index, arr) => index !== removeIndex)
      this.$emit('input', this.dataList ? this.dataList : [])
      this.$emit('change', this.dataList ? this.dataList : [])
    },

    showInput() {
      this.inputVisible = true
    },
    getNewItem(selectedOptions) {
      if (selectedOptions && selectedOptions.length > 1) {
        const item = this.getValueItem(selectedOptions)
        const findIndex = this.dataList.findIndex(dataItem => this.deepEqual(dataItem, item))
        if (findIndex >= 0) {
          return undefined
        }
        return item
      }
      return undefined
    },
    onFocusoutEvent(params) {
      //失去焦点
      let length = params.value.length
      if ((this.areaType === 'all' && length > 2) || (this.areaType !== 'all' && length > 1)) {
        this.inputVisible = false
        const item = this.getNewItem(params.selectedOptions)
        if (item) {
          this.dataList = [item, ...this.dataList]
          this.$emit('input', this.dataList)
          this.$emit('change', this.dataList)
        }
      }
    },
    getAddItem() {
      if (this.areaType === 'in') {
        return {
          label: '国内',
          value: 0
        }
      } else {
        return {
          label: '国外',
          value: 1
        }
      }
    },
    getValueItem(selectedOptions) {
      if (selectedOptions && selectedOptions.length > 0) {
        const list = this.areaType === 'all' ? [...selectedOptions] : [this.getAddItem(), ...selectedOptions]
        const key = list[0].value
        return {
          countryId: key === 1 ? list[1].value : undefined,//国家
          countryName: key === 1 ? list[1].label : undefined,// 国家

          provinceId: key === 0 ? list[1].value : undefined,//省份
          provinceName: key === 0 ? list[1].label : undefined,//省份

          cityId: list[2] ? list[2].value : undefined,//城市
          cityName: list[2] ? list[2].label : undefined,//城市

          countyId: list[3] ? list[3].value : undefined,//区县
          countyName: list[3] ? list[3].label : undefined//区县
        }
      }
      return undefined
    },
    //深入比较对象(判断对象是否相等)
    deepEqual(object_1, object_2) {
      let type1 = typeof object_1
      let type2 = typeof object_2
      if (type1 !== type2) {
        return false
      }
      if (type1 === 'string' || type1 === 'number' || type1 === 'undefined' || type1 === 'boolean') {
        return object_1 === object_2
      }
      if (type1 === 'object') {
        if (type1 instanceof Array) {
          if (object_1.length !== object_1.length) {
            return false
          }
          if (!object_1.every(item => this.containObject(object_2, item))) {
            return false
          }
          if (!object_2.every(item => this.containObject(object_1, item))) {
            return false
          }
          return true
        } else {
          let keys_1 = Object.keys(object_1)
          let keys_2 = Object.keys(object_2)
          if (keys_1.length !== keys_2.length) {
            return false
          }
          let filterKeys = keys_2.filter(key => keys_1.includes(key))
          if (filterKeys.length !== keys_1.length) {
            return false
          }
          for (let i = 0, len = keys_1.length; i < len; i++) {
            let equal = this.deepEqual(object_1[keys_1[i]], object_2[keys_1[i]])
            if (!equal) {
              return false
            }
          }
          return true
        }
      }
      return false
    },
    containObject(list, object) {
      if (!list) {
        return false
      }
      let findIndex = list.findIndex(item => this.deepEqual(item, object))
      return findIndex >= 0
    }
  }

}
</script>